export function updateAppliedOptions(
    giftOptionCode,
    configurationInfos,
    giftOptions = [],
    allowSingleOptionSelection = false,
) {
    const appliedOptions = [];
    let isUniqueOption = true;

    const giftOptionsMessageObj = giftOptions.reduce((acc, giftOption) => {
        const { code, giftOptionMessageEnabled } = giftOption;
        if (giftOptionMessageEnabled) acc[code] = giftOption;
        return acc;
    }, {});

    let isGiftWrapSelected = !giftOptionsMessageObj.hasOwnProperty(giftOptionCode);

    if (configurationInfos.length) {
        configurationInfos.forEach((item, idx) => {
            if (item.configurationLabel === 'giftOptionProductCode') {
                const updateAppliedOptions = allowSingleOptionSelection
                    ? !giftOptionsMessageObj.hasOwnProperty(item.configurationValue) ||
                      item.configurationValue === giftOptionCode ||
                      isGiftWrapSelected
                    : true;
                if (updateAppliedOptions) {
                    appliedOptions.push({
                        giftOptionCode: item.configurationValue,
                        message: configurationInfos[idx + 1].configurationValue,
                    });
                }
                if (item.configurationValue === giftOptionCode) {
                    isUniqueOption = false;
                }
            }
        });
    }

    if (isUniqueOption) {
        appliedOptions.push({ giftOptionCode, message: '' });
    }

    return { appliedOptions, isCurrentOptionApplied: !isUniqueOption };
}

export function removeAppliedOption(giftOptionCode, appliedOptions) {
    return appliedOptions.filter(item => item.giftOptionCode !== giftOptionCode);
}
